// @ts-strict-ignore
import type { ReactiveVar } from "@apollo/client";
import { useReactiveVar } from "@apollo/client";

import type { AnalyticsPayload } from "@shared/hooks/useAnalyticsLogger/useAnalyticsLogger";
import { makeFSVar } from "@shared/reactiveVar/makeFSVar";

type ProductDetailsLoggingVar = {
  entryPoint: AnalyticsPayload["entry_point"];
  additionalPayloadProps: {
    search_rank?: number;
    section?: string;
    origin_sku?: string;
    origin_brand_name?: string;
    alternative_product_rank?: number;
    product_comparison_tag?: string[];
    organic_search_rank?: number;
    search_query_type?: string;
    result_count?: number;
    search_query?: string;
  };
};

const INITIAL_STATE: ProductDetailsLoggingVar = {
  entryPoint: null,
  additionalPayloadProps: {},
};

const productDetailsLoggingVar: ReactiveVar<ProductDetailsLoggingVar> = makeFSVar(
  INITIAL_STATE,
  "useProductDetailsLoggingVar"
);

const resetProductDetailsLogging = () => productDetailsLoggingVar(INITIAL_STATE);

const setProductDetailsEntryPoint = (entryPoint: ProductDetailsLoggingVar["entryPoint"]) => {
  const { entryPoint: unusedEntryPoint, ...rest } = productDetailsLoggingVar();
  productDetailsLoggingVar({ ...rest, entryPoint });
};

const setAdditionalPayloadProps = (
  additionalPayloadProps: ProductDetailsLoggingVar["additionalPayloadProps"]
) => {
  const { additionalPayloadProps: unusedAdditionalPayloadProps, ...rest } =
    productDetailsLoggingVar();
  productDetailsLoggingVar({ ...rest, additionalPayloadProps });
};

const useProductDetailsLoggingVar = (): ProductDetailsLoggingVar =>
  useReactiveVar(productDetailsLoggingVar);

export {
  useProductDetailsLoggingVar,
  setProductDetailsEntryPoint,
  setAdditionalPayloadProps,
  resetProductDetailsLogging,
};
